import api from '../axiosInstance';
import { COMPANY_ENDPOINTS } from '../constants';
import { encodeBase64 } from '../../utils/base64Util';

export const listCompany = () => {
  return api.get(COMPANY_ENDPOINTS.LIST);
}

export const getCompanyDetails = async (Id) => {
  return api.get(COMPANY_ENDPOINTS.GET_By_ID(Id));
}

export const createCompany = async (compDetails) => {
  const data = {
    comp_name: compDetails.comp_name,
    comp_person: compDetails.comp_person,
    comp_gst: compDetails.comp_gst,
    email: compDetails.email,
    mobile: compDetails.mobile,
    comp_address: compDetails.comp_address,
    comp_website: compDetails.comp_website,
    comp_billing_mail: compDetails.comp_billing_mail,
    cred : encodeBase64(compDetails.password),
    status : compDetails.comp_status === 'Active' ? "true" : "false",
  }
  return api.post(COMPANY_ENDPOINTS.CREATE, data)
}

export const editCompany = async (compDetails) => {
  const data = {
    comp_name: compDetails.comp_name,
    comp_person: compDetails.comp_person,
    comp_gst: compDetails.comp_gst,
    mobile: compDetails.mobile,
    comp_address: compDetails.comp_address,
    comp_website: compDetails.comp_website,
    comp_billing_mail: compDetails.comp_billing_mail,
    status : compDetails.comp_status === 'Active' ? "true" : "false",
  }
  console.log('we in put');
  return api.put(COMPANY_ENDPOINTS.UPDATE(compDetails.comp_id), data)
}

export const deleteCompany = async (Id) => {
  return api.delete(COMPANY_ENDPOINTS.DELETE(Id))
} 

export const showPassCode = async (Id) => {
  return api.get(COMPANY_ENDPOINTS.PASSCODE(Id))
}